/* eslint-disable react/no-danger */
import { ArrowUp16 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './SeoMarkedListItem.css';

const SPACE_KEY_CODE = 32;

export interface ISeoMarkedListItemProps {
  id: string;
  title: string;
  content: string;
}

export const SeoMarkedListItem: React.VFC<ISeoMarkedListItemProps> = ({ id, title, content }) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const headingId = `${id}_heading`;
  const bodyId = `${id}_body`;

  const toggleExpandedState = () => {
    setExpanded(!expanded);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === SPACE_KEY_CODE) {
      event.preventDefault();

      toggleExpandedState();
    }
  };

  return (
    <div className={classNames(styles['container'], !expanded && styles['closed'])}>
      {/**
        Почему здесь не стоит использовать button описано тут
        https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role
      */}
      <div
        id={headingId}
        role="button"
        aria-expanded={expanded}
        aria-controls={bodyId}
        tabIndex={0}
        className={styles['title-block']}
        onClick={toggleExpandedState}
        onKeyDown={handleKeyDown}
      >
        <div className={styles['title']} dangerouslySetInnerHTML={{ __html: title }} />
        <div className={styles['arrow-wrapper']}>
          <ArrowUp16 />
        </div>
      </div>
      <div
        id={bodyId}
        aria-describedby={headingId}
        className={styles['content']}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};
